export enum SectionBackgroundColor {
  White = 'white',
  Sand = 'sand',
  SecondaryLighter = 'secondary-lighter',
  LightGrey = 'light-grey',
  LightBlue = 'light-blue',
  Green = 'green',
  Primary = 'primary',
  Cyan = 'cyan',
  OceanBlue = 'ocean-blue',
}

export const SECTION_COLORS = new Map<SectionBackgroundColor, string>([
  [SectionBackgroundColor.White, '--background'],
  [SectionBackgroundColor.Sand, '--color-secondary-lighter'],
  [SectionBackgroundColor.SecondaryLighter, '--color-secondary-lighter'],
  [SectionBackgroundColor.LightGrey, '--color-card-bg'],
  [SectionBackgroundColor.LightBlue, '--color-light-blue'],
  [SectionBackgroundColor.Green, '--color-green'],
  [SectionBackgroundColor.Primary, '--color-primary'],
  [SectionBackgroundColor.Cyan, '--gradient-from'],
  [SectionBackgroundColor.OceanBlue, '--gradient-to'],
]);

export const getSectionColorVar = (color: SectionBackgroundColor): string =>
  `var(${SECTION_COLORS.get(color)!})`;

export const SECTION_COLOR_CLASS = new Map<SectionBackgroundColor, string>([
  [SectionBackgroundColor.White, 'bg-[var(--background)]'],
  [SectionBackgroundColor.Sand, 'bg-[var(--color-secondary-lighter)]'],
  [
    SectionBackgroundColor.SecondaryLighter,
    'bg-[var(--color-secondary-lighter)]',
  ],
  [SectionBackgroundColor.LightGrey, 'bg-[var(--color-card-bg)]'],
  [SectionBackgroundColor.LightBlue, 'bg-[var(--color-light-blue)]'],
  [SectionBackgroundColor.Green, 'bg-[var(--color-green)]'],
  [SectionBackgroundColor.Primary, 'bg-[var(--color-primary)]'],
  [SectionBackgroundColor.Cyan, 'bg-[var(--gradient-from)]'],
  [SectionBackgroundColor.OceanBlue, 'bg-[var(--gradient-to)]'],
]);

export const getSectionColorClass = (
  color: SectionBackgroundColor,
): string | undefined => SECTION_COLOR_CLASS.get(color);
